import moment from 'moment';

// When a contract ended (US 9371), e.g. "31 Oct 2026". It is stored as a date, so only the day is read.
export function endedOn(value) {
  return value ? moment(String(value).slice(0, 10), 'YYYY-MM-DD').format('D MMM YYYY') : '';
}
